import $ from 'jquery';
import { medicatedProducts } from '../../data/medicated-products-data.js';

class MedicatedProductModal {
	constructor() {
		this.$modal = $('#modal-medicated-product');
		if (!this.$modal.length) return;

		this.$backdrop = this.$modal.find('.modal__backdrop');
		this.$closeBtn = this.$modal.find('.modal__close');
		this.currentProduct = null;

		this.init();
	}

	// HTMLタグを除去するヘルパーメソッド
	stripHtmlTags(str) {
		if (!str) return '';
		return str.replace(/<[^>]*>/g, '');
	}

	init() {
		// カードクリックイベント
		$('.products_medicated .products_items_card[data-product-id]').on('click', (e) => {
			const productId = $(e.currentTarget).data('product-id');
			this.openModal(productId);
		});

		// 閉じるボタン
		this.$closeBtn.on('click', () => this.closeModal());

		// 背景クリック
		this.$backdrop.on('click', () => this.closeModal());

		// ESCキー
		$(document).on('keydown', (e) => {
			if (e.key === 'Escape' && this.$modal.hasClass('is-active')) {
				this.closeModal();
			}
		});

		// 外部モジュール（labo-modal 等）からの起動リクエスト
		window.addEventListener('openMedicatedProductModal', (e) => {
			const productId = e.detail?.productId;
			if (productId) this.openModal(productId);
		});
	}

	openModal(productId) {
		const product = medicatedProducts.find(p => p.id === productId);
		if (!product) return;

		this.currentProduct = product;
		this.renderModal(product);

		// 製品固有のクラスを追加
		this.$modal.addClass(`modal-medicated-product--${product.id}`);

		// モーダルのスクロール位置を最上部にリセット
		this.$modal.find('.modal-medicated-product_body').scrollTop(0);

		// botanical製品の場合、ラベルを表示する
		if (product.id === 'botanical') {
			this.$modal.find('.modal-medicated-product_price-label').hide();
		} else {
			this.$modal.find('.modal-medicated-product_price-label').show();
		}

		// フェードインアニメーション
		$('body').css('overflow', 'hidden');

		// 2回のrequestAnimationFrameで確実にレンダリングを待つ
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.$modal.addClass('is-active');
			});
		});
	}

	closeModal() {
		// フェードアウトアニメーション
		this.$modal.removeClass('is-active');

		// 製品固有のクラスを削除
		if (this.currentProduct) {
			this.$modal.removeClass(`modal-medicated-product--${this.currentProduct.id}`);
		}

		// アニメーション完了後にbodyのスクロールを復元
		setTimeout(() => {
			$('body').css('overflow', '');
		}, 300); // transitionの時間と同じ
	}


	renderModal(product) {
		console.log(product)
		// 商品画像
		this.$modal.find('.modal-medicated-product_product-img').attr('src', product.images.product);
		this.$modal.find('.modal-medicated-product_product-img').attr('alt', this.stripHtmlTags(product.name));

		// メインコピー
		this.$modal.find('.modal-medicated-product_main-copy').html(product.mainCopy);

		// ヘッディングタグ
		const $headingTag = this.$modal.find('.modal-medicated-product_heading-tag');
		$headingTag.text(product.headingTag.text);
		$headingTag.removeClass('tag_pink tag_blue tag_green tag_purple');
		$headingTag.addClass(`tag_${product.headingTag.color}`);

		// 商品名
		this.$modal.find('.modal-medicated-product_name').html(product.name);

		// 医薬部外品タグ
		const $tag = this.$modal.find('.modal-medicated-product_tag');
		if (product.tag) {
			$tag.text(product.tag).show();
		} else {
			$tag.hide();
		}

		// 価格
		this.$modal.find('.modal-medicated-product_price-amount').text(product.price);

		// 注釈
		const $note = this.$modal.find('.modal-medicated-product_note');
		if (product.note) {
			$note.text(product.note).show();
		} else {
			$note.hide();
		}

		// 説明文
		this.$modal.find('.modal-medicated-product_description').html(product.description);

		// おすすめリスト
		const $recommendList = this.$modal.find('.modal-medicated-product_recommend-list');
		$recommendList.empty();
		product.recommendations.forEach(item => {
			$recommendList.append(`<li>${item}</li>`);
		});

		// 成分のこだわり - マーカーテキスト
		if (product.ingredientsHighlight) {
			this.$modal.find('.modal-medicated-product_ingredients-highlight-title').html(product.ingredientsHighlight.title);
			const $highlightDesc = this.$modal.find('.modal-medicated-product_ingredients-highlight-desc');
			if (product.ingredientsHighlight.description) {
				$highlightDesc.html(product.ingredientsHighlight.description).show();
			} else {
				$highlightDesc.hide();
			}
		}

		// 成分のこだわり画像（レスポンシブ）
		this.$modal.find('.modal-medicated-product_ingredients-image source').attr('srcset', product.images.ingredientsSp);
		this.$modal.find('.modal-medicated-product_ingredients-image img').attr('src', product.images.ingredientsPc);

		// バッジ
		const $badges = this.$modal.find('.modal-medicated-product_badges');
		$badges.empty();
		if (product.badges && product.badges.length > 0) {
			product.badges.forEach(badge => {
				$badges.append(`<div class="modal-medicated-product_badge">${badge}</div>`);
			});
		}

		// バッジExtra
		const $badgesExtra = this.$modal.find('.modal-medicated-product_badges-extra');
		$badgesExtra.empty();
		if (product.badgesExtra && product.badgesExtra.length > 0) {
			product.badgesExtra.forEach(badge => {
				$badgesExtra.append(`<div class="modal-medicated-product_badge-extra">${badge}</div>`);
			});
			$badgesExtra.show();
		} else {
			$badgesExtra.hide();
		}

		// フッター
		this.$modal.find('.modal-medicated-product_ingredients-footer').html(product.footer);

		// 購入ボタン
		const $purchaseBtn = this.$modal.find('.modal-medicated-product_purchase-btn');
		const $purchaseNote = this.$modal.find('.modal-medicated-product_purchase-note');
		if (product.purchaseUrl) {
			$purchaseBtn.attr('href', product.purchaseUrl).show();
			$purchaseNote.hide();
		} else {
			$purchaseBtn.hide();
			$purchaseNote.text(product.purchaseNote || '').show();
		}
	}
}

$(() => {
	new MedicatedProductModal();
});

export default MedicatedProductModal;
